import { useCMSPageField } from '@/cms/fields'
import { useCheckoutSid, useCheckoutUsps } from '@/scopes/checkout/domain/hooks'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { BulletList, Icon, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled(BulletList.Root)`
  align-content: center;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
`

const CheckoutUsp = styled(BulletList.Item)`
  ${Icon} {
    color: ${tk('color_palette_green_500')};
  }
`

function CheckoutUspItems(props: { componentId: string }) {
  const { componentId } = props
  const { data, isLoading } = useCheckoutUsps(componentId)
  const { isDesktopSm } = useBreakpoints()
  if (isLoading)
    return ''
  if (!data)
    return ''

  return (
    <Wrapper $type={isDesktopSm ? 'inline' : 'vertical'}>
      {data?.usps.map(item => (
        <CheckoutUsp key={item.text} $icon={item.icon ?? 'IconCheckmark'}>
          <Typography $variant="label" dangerouslySetInnerHTML={{ __html: item.text }} />
        </CheckoutUsp>
      ))}
    </Wrapper>
  )
}

export function CheckoutUsps() {
  const sid = useCheckoutSid()
  const items = useCMSPageField('Checkout.usps')?.items ?? []

  if (!sid) {
    return null
  }

  return (
    <>
      {items?.map(({ componentId }) => {
        return <CheckoutUspItems key={componentId} componentId={componentId} />
      })}
    </>
  )
}
